export default __webpack_public_path__ + "static/Sponge Logo-50ad0329984ea00534ca889d25eb131a.png";